import { getCookie } from '@zola-helpers/client/dist/es/util/storage';

export const isAutomatedTest = () => {
  return typeof window !== 'undefined' && getCookie('automatedTest') === 'true';
};

export const isAutomatedTestSSR = (cookies: { [key: string]: string }) => {
  return cookies.automatedTest === 'true';
};
